export default __webpack_public_path__ + "static/media/laptop-success.729ba406.png";